export type SpinnerSize = 'sm' | 'md' | 'lg'

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-3.5 w-3.5 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]'
}

export type SpinnerProps = {
  size?: SpinnerSize
  className?: string
  /** 覆盖边框配色；默认灰环 + 主题主色头 */
  borderClassName?: string
}

export function Spinner({
  size = 'md',
  className = '',
  borderClassName = 'border-[var(--color-line)] border-t-[var(--color-primary)]'
}: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="加载中"
      className={`inline-block animate-spin rounded-[var(--radius-pill)] ${borderClassName} ${sizeClasses[size]} ${className}`.trim()}
    />
  )
}
